import { schema } from "normalizr";
import userSchema from "./user";

const tokenSchema = new schema.Entity(
    "tokens",
    {
        user: userSchema
    },
    { idAttribute: "token" }
);

export default tokenSchema;



// WEBPACK FOOTER //
// ./src/schemas/token.js